module.exports = __webpack_public_path__ + "static/media/hrlocker.ebec1b9f.png";